<template>
  <div
    class="l-switch-bg rounded-full flex items-center !w-9 !h-[1.125rem]"
    :class="{
      'bg-r-300': model == 0,
      'bg-g-500': model == 1,
      'bg-n-200': model == 2,
      'opacity-50': disabled,
      'cursor-pointer': !disabled
    }"
    @click.stop="emitInput"
  >
    <div
      class="flex justify-center items-center rounded-full bg-n-0 shadow l-switch-button"
      :class="{
        'l-active-button': model == 1,
        'l-half-button': model == 2
      }"
    >
      <div class="flex items-center justify-center w-4 h-4">
        <l-icon
          :name="iconName"
          size="x-small"
          :class="{
            'text-r-300': model == 0,
            'text-g-500': model == 1,
            'text-n-200': model == 2
          }"
        />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import LIcon from './LIcon.vue'

type NumberAsValue = 0 | 1 | 2

type Props = {
  disabled?: boolean
  enableOnPartialState?: boolean
}
const props = withDefaults(defineProps<Props>(), {
  disabled: false,
  enableOnPartialState: false
})

const model = defineModel<boolean | NumberAsValue>()

const emitInput = () => {
  if (!props.disabled) {
    if (props.enableOnPartialState && model.value == 2) {
      model.value = true
    } else {
      model.value = !model.value
    }
  }
}

const iconName = computed(() => {
  if (model.value === 2) {
    return 'minus'
  } else if (model.value == 1) {
    return 'check'
  }

  return 'close'
})
</script>

<style scoped>
.l-switch-bg {
  transition: all 0.5s;
}

.l-switch-button {
  transition: all 0.5s;
  margin: 1px;
}

.l-active-button {
  margin-left: 1.1875rem;
}

.l-half-button {
  margin-left: 0.625rem;
}
</style>
